<template>
  <div
    class="rorschach"
    :class="rorschachClasses"
  >
    <div
      class="wrapper"
      :class="pausedClasses"
      :style="{
        'background-image': `url(${poster})`
      }"
    >
      <video
        muted
        autoplay
        playsinline
        class="video"
        ref="video"
        :src="src"
        poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        @playing="paused = false"
      ></video>
    </div>
    <p
      v-if="hasDefaultSlot"
      class="p"
      :class="{
        'text-center': center
      }"
    >
      <slot></slot>
    </p>
  </div>
</template>

<script>
import { mediaQueryMixin } from '@/mixins'

export default {
  name: 'Rorschach',
  data () {
    return {
      paused: true
    }
  },
  mixins: [mediaQueryMixin],
  props: {
    src: {
      type: String,
      required: true
    },
    center: {
      type: Boolean,
      default: false
    },
    poster: {
      type: String,
      required: true
    },
    light: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    pausedClasses () {
      return {
        'paused': this.paused && this.mobile,
        'desktop': !this.mobile
      }
    },
    rorschachClasses () {
      return {
        'light': this.light
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rorschach {
  margin-bottom: 16px;
  text-align: center;
  border: none;
  outline: 0;
}
.wrapper, .video {
  width: 300px;
  height: 300px;
  font-size: 0;
  margin: 0 auto;
  border: none;
  outline: 0;

  @media (min-width: 768px) {
    width: 500px;
    height: 500px;
  }
}
.light {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(235, 234, 233, 0) 90%, $c-light 100%), linear-gradient(to left, rgba(235, 234, 233, 0) 90%, $c-light 100%), linear-gradient(to right, rgba(235, 234, 233, 0) 90%, $c-light 100%), linear-gradient(to bottom, rgba(235, 234, 233, 0) 90%, $c-light 100%);
  }
}
.paused {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  .video {
    display: none;
  }
}
.desktop {
  background: none !important;

  .video {
    display: block;
  }
}
.video {
  background-color: transparent;
}
.image {
  max-width: 100%;
  height: auto;
}
.p {
  font-size: 32px;
  font-weight: bold;
  text-align: left;
  position: relative;
  color: $c-darktext;
}
.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/person/Rorschach.vue